import React from 'react';
import { connect } from 'react-redux';
import './styles/footer.css';
import { originalsPaths } from '../../../Data/excludedPaths';
import { FooterBody, FooterContent, FooterTitle, FooterText, PagesLink, SocialLinks, SocialMedia, FooterContainer } from './styles';
import { SiteGreyLogo, SiteWhiteLogo, SiteDarkModeLogo } from '../SiteLogo';
import { FaRegCopyright, FaYoutube, FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const Footer = ({ isFromInterview, country, userPaidStatus, paidPath, isPricingBar, variant }) => {
  let footerLink = `?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=footer`;
  let partnerPlusLink = `/partner-plus/${footerLink}`;
  let regionalsLink = `/regionals/${footerLink}`;
  let codeJuniorsLink = `/code-juniors/${footerLink}`;
  let beginners = `/beginners/${footerLink}`;
  let cProgram = `/c-programming/${footerLink}`;
  let python = `/python/${footerLink}`;
  let dsa = `/dsa/${footerLink}`;
  let interView = `/interview/${footerLink}`;
  let frontendDevelopment = `/frontend-development/${footerLink}`;
  let selenium = `/selenium/${footerLink}`;
  let dataAnalysis = `/data-analysis/${footerLink}`;
  let tamil = `/tamil/${footerLink}`;
  let tamilAnimation = `/tamil-animation-courses/${footerLink}`;
  let tamilExpert = `/tamil-expert-courses/${footerLink}`;
  let telugu = `/telugu/${footerLink}`;
  let hindi = `/hindi/${footerLink}`;
  let kannada = `/kannada/${footerLink}`;
  let bengali = `/bengali/${footerLink}`;
  let reviews = `/reviews/${footerLink}`;
  let contact = `/contact/${footerLink}`;
  let mothertong = `https://mothertong.com/${footerLink}`;
  let blog = `/blog/${footerLink}`;
  let pricing = `/pricing/${footerLink}`;
  let studentOffer = `/student-offer/${footerLink}`;
  let groupPurchase = `/student-group-purchase/${footerLink}`;
  let buyCourses = `/buy-courses/${footerLink}`;
  let buyPackages = `/buy-packages/${footerLink}`;
  let business = `/business/${footerLink}`;
  let hire = `https://hirefreshers.log2base2.com/${footerLink}`;
  let term = `/terms-and-conditions/${footerLink}`;
  let policy = `/privacy-policy/${footerLink}`;
  let refund = `/refund-policy/${footerLink}`;

  return (
    <FooterContainer
      // variant={variant}
      isFromInterview={isFromInterview}
      isPricingBar={isPricingBar}
    >
      <FooterBody>
        <FooterContent id="footer-head">
          <a id="footer-logo-link" href="/">
            <div id="footer-svg-logo">{isFromInterview ? <SiteDarkModeLogo /> : <SiteGreyLogo />}</div>
          </a>
          <FooterText isFromInterview={isFromInterview}>
            <FaRegCopyright /> Log2Base2 Edutech Media Pvt Ltd
          </FooterText>
          <FooterText isFromInterview={isFromInterview}>All rights reserved</FooterText>
          <SocialLinks>
            <SocialMedia target="_blank" href="https://www.youtube.com/c/log2base2" isFromInterview={isFromInterview} rel="noopener noreferrer">
              <FaYoutube />
            </SocialMedia>
            <SocialMedia target="_blank" href="https://www.facebook.com/log2base2" isFromInterview={isFromInterview} rel="noopener noreferrer">
              <FaFacebookF />
            </SocialMedia>
            <SocialMedia target="_blank" href="https://twitter.com/log2base2" isFromInterview={isFromInterview} rel="noopener noreferrer">
              <FaTwitter />
            </SocialMedia>
            <SocialMedia target="_blank" href="https://www.instagram.com/log2base2/" isFromInterview={isFromInterview} rel="noopener noreferrer">
              <FaInstagram />
            </SocialMedia>
            <SocialMedia target="_blank" href="https://www.linkedin.com/company/log2base2/" isFromInterview={isFromInterview} rel="noopener noreferrer">
              <FaLinkedinIn />
            </SocialMedia>
          </SocialLinks>
        </FooterContent>
        <FooterContent id="footer-products">
          <FooterTitle isFromInterview={isFromInterview}>Products</FooterTitle>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={'/'}>
              Originals
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={regionalsLink} target="_blank" rel="noreferrer noopener">
              Regionals
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={codeJuniorsLink} target="_blank" rel="noreferrer noopener">
              Code Juniors
            </PagesLink>
            {/*<span className="site-badge juniors-bg-color text-white fs-11 ml-1">KIDS</span>*/}
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={partnerPlusLink} target="_blank" rel="noreferrer noopener">
              Partner+ Courses
            </PagesLink>
            {/*<span className="site-badge partner-bg-color text-white fs-11 ml-1">NEW</span>*/}
          </span>
        </FooterContent>
        <FooterContent id="footer-packages">
          <FooterTitle isFromInterview={isFromInterview}>Original Packages</FooterTitle>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={beginners}>
              Beginners
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={cProgram}>
              C & Pointers
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={python}>
              Python
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={dsa}>
              Data Structures & Algorithms
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={interView}>
              Interview Preparation
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={frontendDevelopment}>
              Frontend Development
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={selenium}>
              Selenium
            </PagesLink>
          </span>
        </FooterContent>
        {/* regionals starts */}
        {country === 'IN' && (
          <FooterContent id="footer-regionals">
            <FooterTitle isFromInterview={isFromInterview}>Regional Packages</FooterTitle>
            <span>
              <PagesLink isFromInterview={isFromInterview} href={tamil}>
                தமிழ் (Tamil)
              </PagesLink>
            </span>
            <span>
              <PagesLink isFromInterview={isFromInterview} href={tamilAnimation}>
                தமிழ் (Tamil) - Animated Courses
              </PagesLink>
            </span>
            <span>
              <PagesLink isFromInterview={isFromInterview} href={tamilExpert}>
                தமிழ் (Tamil) - Expert Courses
              </PagesLink>
            </span>
            <span>
              <PagesLink isFromInterview={isFromInterview} href={telugu}>
                తెలుగు (Telugu)
              </PagesLink>
            </span>
            <span>
              <PagesLink isFromInterview={isFromInterview} href={hindi}>
                हिन्दी (Hindi)
              </PagesLink>
            </span>
            <span>
              <PagesLink isFromInterview={isFromInterview} href={kannada}>
                ಕನ್ನಡ (Kannada)
              </PagesLink>
            </span>
            <span>
              <PagesLink isFromInterview={isFromInterview} href={bengali}>
                বাংলা (Bengali)
              </PagesLink>
            </span>
          </FooterContent>
        )}
        {/* regionals ends */}
        <FooterContent id="footer-partner-packages">
          <FooterTitle isFromInterview={isFromInterview}>Partner+ Packages</FooterTitle>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={dataAnalysis}>
              Data Analysis
            </PagesLink>
          </span>
        </FooterContent>
        <FooterContent id="footer-links">
          <FooterTitle isFromInterview={isFromInterview}>Links</FooterTitle>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={pricing}>
              Pricing
            </PagesLink>
          </span>
          {/*<span>
            <PagesLink isFromInterview={isFromInterview} href={studentOffer}>
              Student Offer
            </PagesLink>{' '}
            {!userPaidStatus || paidPath === undefined || (paidPath && originalsPaths.every((path) => !paidPath.includes(path))) ? (
              <span className="site-badge bg-primary text-white fs-11 ml-1">SAVE BIG</span>
            ) : null}
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={groupPurchase}>
              Student Group Purchase
            </PagesLink>
          </span>
          */}
          <span>
            <PagesLink isFromInterview={isFromInterview} href={buyCourses}>
              Buy Individual courses
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={buyPackages}>
              Buy Packages
            </PagesLink>
          </span>
          {/*<span><PagesLink isFromInterview={isFromInterview} href="/affiliate">Affiliate</PagesLink></span>*/}
          <span>
            <PagesLink isFromInterview={isFromInterview} href={hire}>
              For Fresher Hiring
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={business}>
              For Business
            </PagesLink>
          </span>
        </FooterContent>
        <FooterContent id="footer-company">
          <FooterTitle isFromInterview={isFromInterview}>Company</FooterTitle>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={reviews}>
              Success Stories
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={contact}>
              Contact us
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={mothertong}>
              Mothertong
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={blog}>
              Blog
            </PagesLink>
          </span>
        </FooterContent>
        <FooterContent id="footer-legal">
          <FooterTitle isFromInterview={isFromInterview}>Legal</FooterTitle>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={term}>
              Terms & Conditions
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={policy}>
              Privacy Policy
            </PagesLink>
          </span>
          <span>
            <PagesLink isFromInterview={isFromInterview} href={refund}>
              Refund Policy
            </PagesLink>
          </span>
        </FooterContent>
      </FooterBody>
    </FooterContainer>
  );
};

const mapStateToProps = ({ User, Dashboard }) => ({
  country: User.locationDetails && User.locationDetails.country,
  userPaidStatus: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.paidStatus,
  paidPath: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.path,
});

export default connect(mapStateToProps, null)(Footer);
